module.exports = __webpack_public_path__ + "static/img/icon.d36a380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.png
// module id = 173
// module chunks = 25